import { useInjection } from 'inversify-react';
import { useCallback } from 'react';

import { AnimationManager } from '../../../../core/viewer/animation-manager';
import { TYPES } from '../../../../inversify.types';
import { ShadowRootContent } from '../ShadowRootContent/ShadowRootContent';

export const AnimatedSVGContainer = ({ id, content }: { id: number; content: string }) => {
  const { animateIn } = useInjection<AnimationManager>(TYPES.Viewer.AnimationManager);

  const runAnimateInOnCallbackRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (!node) return;

      animateIn();
    },
    [content, animateIn]
  );

  return <ShadowRootContent content={content} pageId={id} ref={runAnimateInOnCallbackRef} />;
};
